import React from 'react'
import { connect } from '@cerebral/react'
import { props, signal, state } from 'cerebral/tags'
import { css } from 'aphrodite'
import Measure from 'react-measure'
import crumbsFromNodePath from 'modules/Node/computed/crumbsFromNodePath'
import styles from './styles'

const arrowWidth = 22
const averageTextWidth = 90
const condensedTextWidth = 30
const minCondensedTextWidth = 0

const averageSize = averageTextWidth + arrowWidth

const textSizeDiff = averageTextWidth - condensedTextWidth
const condensedStartIndex = 1
const condensedLastIndex = 1
const ineligbleCount = condensedStartIndex + condensedLastIndex

const calculateCondensedCrumbs = (width, count) => {
  const eligibleCrumbs = count - ineligbleCount
  const remainingWidth =
    width - averageSize * ineligbleCount - arrowWidth * eligibleCrumbs
  const neededCount =
    -(remainingWidth - eligibleCrumbs * averageTextWidth) / textSizeDiff
  if (Math.ceil(neededCount) < eligibleCrumbs)
    return [Math.ceil(neededCount), condensedTextWidth]

  const scaledWidth = Math.floor(remainingWidth / eligibleCrumbs)

  const scaled =
    scaledWidth > minCondensedTextWidth
      ? scaledWidth > condensedTextWidth ? condensedTextWidth : scaledWidth
      : minCondensedTextWidth

  return [eligibleCrumbs, scaled]
}

const getCrumbs = (
  [path, ...paths],
  condensedCount,
  condenseWidth,
  acc = []
) => {
  if (!path) return acc
  const condensed =
    condensedCount > 0 &&
    acc.length >= condensedStartIndex &&
    paths.length >= condensedLastIndex

  return getCrumbs(
    paths,
    condensed ? condensedCount - 1 : condensedCount,
    condenseWidth,
    [
      ...acc,
      <Crumb
        key={acc.length}
        condensed={condensed}
        condenseWidth={condenseWidth}
        path={path}
      />
    ]
  )
}

const Crumb = connect(
  {
    node: state`${props`path`}`,
    path: props`path`,
    selectNode: signal`node.selectNode`
  },
  ({ node, path, selectNode, condensed, condenseWidth }) => {
    if (!node) return null
    const { id, name } = node
    return (
      <span
        onClick={() => selectNode({ id, path })}
        className={css(styles.crumb)}
        title={name}
      >
        <span
          className={css(styles.crumbContent)}
          style={condensed ? { maxWidth: condenseWidth } : null}
        >
          {name}
        </span>
      </span>
    )
  }
)

export default connect(
  {
    nodePaths: crumbsFromNodePath
  },
  ({ nodePaths }) => {
    if (!nodePaths) return null
    return (
      <Measure>
        {({ measureRef, contentRect: { entry } }) => {
          const [condensedCount, condenseWidth] = calculateCondensedCrumbs(
            entry.width,
            nodePaths.length
          )
          return (
            <div ref={measureRef} className={css(styles.breadcrumbs)}>
              {getCrumbs(nodePaths, condensedCount, condenseWidth)}
            </div>
          )
        }}
      </Measure>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/Breadcrumbs/index.js